<div>
  <p-dialog header="Add new recipient" [(visible)]="activeReceiverForm" [modal]="true">
    <div [formGroup]="receiverForm" class="receiver-form">
      name
      <input formControlName="name">
      street, number
      <input formControlName="street">
      post code
      <input formControlName="postCode">
      city
      <input formControlName="city">
      VAT number
      <input formControlName="vatNumber">
      Other information
      <input formControlName="option">
      <button (click)="postReceiver()">Confirm</button>
    </div>
  </p-dialog>
  <div [formGroup]="invoiceForm" *ngIf="invoiceForm">
    <div class="receiver-form">
      <p>
        Recipient
      </p>
      <p-dropdown placeholder="Select" dataKey="id" [options]="invoiceReceivers" optionLabel="name"
        formControlName="invoiceReceiver"></p-dropdown>
      <button (click)="activateReceiverForm()">Add invoice recipient</button>
      <div *ngIf="invoiceForm.value.invoiceReceiver">
        <p>
          {{invoiceForm.value.invoiceReceiver.name}}
        </p>
        <p>
          {{invoiceForm.value.invoiceReceiver.street}}
        </p>
        <p>
          {{invoiceForm.value.invoiceReceiver.postCode}} {{invoiceForm.value.invoiceReceiver.city}}
        </p>
        <p>
          {{invoiceForm.value.invoiceReceiver.vatNumber}}
        </p>
        <p>
          {{invoiceForm.value.invoiceReceiver.option}}
        </p>
      </div>
    </div>
    <table class="transaction-table">
      <tr class="first-table-row">
        <th>#</th>
        <th class="description-th">Remarks</th>
        <th>Net price</th>
        <th>VAT Rate</th>
      </tr>
      <tr class="no-record-tr" *ngIf="lineItemsFormArray.length==0">
        <td colspan="6">
          <div class="no-record-row">
            <p class="no-record-message">
              No record
            </p>
            <div class="icon-wrap" (click)="insertItem(0)">
              <i class="pi pi-plus"></i>
            </div>
          </div>
        </td>
      </tr>
      <tr formArrayName="lineItems" *ngFor="let lineItem of lineItemsFormArray; let i = index"
        (mouseenter)="mouseover(i)" (mouseleave)="mouseout(i)">
        <td [formGroupName]="i">
          {{i + 1}}
        </td>
        <td [formGroupName]="i" class="description-container">
          <textarea [rows]="1" pInputTextarea formControlName="description" [autoResize]="true"
            id="description-input"></textarea>
        </td>
        <td [formGroupName]="i">
          <input pInputText formControlName="netAmount" id="amount-input">
        </td>
        <td [formGroupName]="i">
          {{lineItem.value.vatRate.label}}
        </td>
        <td class="menu-head">
          <table class="hover-menu" [hidden]="isHidden(i)">
            <tr>
              <td>
                <div class="icon-container">
                  <i class="pi pi-caret-up" (click)="moveUp(i)"></i>
                </div>
              </td>
              <td>
                <div class="icon-container">
                  <i class="pi pi-caret-down" (click)="moveDown(i)"></i>
                </div>
              </td>
              <td>
                <div class="icon-container">
                  <i class="pi pi-plus-circle" (click)="insertItem(i)"></i>
                </div>
              </td>
              <td>
                <div class="icon-container">
                  <i class="pi pi-times-circle"></i>
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
  <button (click)="postInvoice()">Emit invoice</button>
</div>